import { OAuthStorage } from 'angular-oauth2-oidc';

/**
 * Storage for angular-oauth2-oidc backed by localStorage.
 *
 * Tokens (access/refresh/id) plus the transient PKCE code_verifier/nonce/state live in
 * localStorage, which is shared across every tab/window of this origin and survives a tab
 * close. This deliberately replaces the previous per-tab sessionStorage scheme to remove
 * the friction it caused: opening a new tab forcing a fresh AS round-trip, and -- because
 * Arc opens the OIDC redirect/callback in a separate tab -- the PKCE verifier landing in a
 * different tab's storage than the one that started the flow, so the code exchange failed.
 *
 * Tradeoff accepted: tokens are readable by any script on this origin (XSS) and persist on
 * disk until an explicit logout or expiry, rather than clearing on tab close. Because the
 * refresh token is now shared across tabs, every refresh MUST be serialized across tabs to
 * avoid rotating-refresh-token reuse detection revoking the whole grant -- see
 * OidcAuthService.serializeRefreshAcrossTabs.
 */
export class LocalStorageOAuthStorage extends OAuthStorage {
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setItem(key: string, data: string): void {
    localStorage.setItem(key, data);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
